<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="keyboard_shortcuts"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_keyboard_shortcut_index_503')">
      <Form ref="keyboard_shortcut"
            :model="keyboard_shortcut"
            :label-width="80">
        <Form-item :label="$t('pages_ai_image_158')"
                   prop="name">
          <Input type="text"
                 v-model="keyboard_shortcut.name" />
        </Form-item>
        <Form-item :label="$t('pages_keyboard_shortcut_index_504')"
                   prop="value">
          <Input type="text"
                 v-model="keyboard_shortcut.value" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      banner_platforms: [
        { text: '', code: '' },
        { text: i18n.t('libs_table_render_52'), code: 'mini' },
        { text: i18n.t('libs_table_render_51'), code: 'front' }
      ],
      banner_categories: [
        { text: '', code: '' },
        { text: i18n.t('libs_table_render_86'), code: 'picture' },
        { text: i18n.t('libs_table_render_87'), code: 'video' }
      ],
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_banners_index_181'),
          key: 'name',
        },
        {
          title: i18n.t('pages_keyboard_shortcut_index_504'),
          key: 'value',
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('keyboard_shortcut', ['keyboard_shortcut', 'keyboard_shortcuts', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('keyboard_shortcut', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('keyboard_shortcut', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    change_platform (e) {
      this.keyboard_shortcut.platform = e.value
    },
    change_category (e) {
      this.keyboard_shortcut.category = e.value
    },
    uploadedUrl (url) {
      this.keyboard_shortcut.image = url
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.keyboard_shortcut)
      } else if (this.formType === 'new') {
        await this.create(this.keyboard_shortcut)
      }
      this.modalShow = false
    }
  }
}
</script>
